import { call, METHODS } from "./ApiProvider";

const getDashboardStatistics = async (values) => {
    const { token, DateFilter = 'today', ...parameters } = values;
    return await call(`/report/dashboard/statistics`, METHODS.GET, token, {
        DateFilter,
        ...parameters
    });
};

const getBranchRevenueReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/revenue`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getSalesSummaries = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/sales/summaries`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranches = async (values) => {
    const { token, CompanyCode, ...parameters } = values;
    return await call(`/branchs`, METHODS.GET, token, {
        CompanyCode,
        ...parameters
    });
};

const getBranchPaymentReport = async (values) => {
    const { token, DateFilter = 'today', PaymentType, BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/payment`, METHODS.GET, token, {
        DateFilter,
        PaymentType,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchCustomerCountReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/customer-count`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchOpenTableCountReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/open-table-count`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchDayStartEndTimesReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/day-start-end-times`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchStaffCountReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/staff-count`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchUnpaidReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/unpaid`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchGiftReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/gift`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchTopProductsReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, OrderBy = 'DESC', ...parameters } = values;
    return await call(`/report/branch/top-products`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        OrderBy,
        ...parameters
    });
};

const getBranchTopWaitersReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/top-waiters`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getBranchAverageTableConsumptionReport = async (values) => {
    const { token, DateFilter = 'today', BranchCode, StartDate, EndDate, ...parameters } = values;
    return await call(`/report/branch/average-table-consumption`, METHODS.GET, token, {
        DateFilter,
        BranchCode,
        StartDate,
        EndDate,
        ...parameters
    });
};

const getProductCostSalesRatioReport = async (values) => {
    const { token, BranchCode, ...parameters } = values;
    return await call(`/report/product-cost-sales-ratio`, METHODS.GET, token, {
        BranchCode,
        ...parameters
    });
};

const getBranchCriticalStockReport = async (values) => {
    const { token, BranchCode, CriticalLevel = 10, ...parameters } = values;
    return await call(`/report/branch/critical-stock`, METHODS.GET, token, {
        BranchCode,
        CriticalLevel,
        ...parameters
    });
};

const ReportService = {
    dashboard: {
        getDashboardStatistics,
        getBranchRevenueReport
    },
    sales: {
        getSalesSummaries,
        getBranchTopProductsReport,
        getBranchTopWaitersReport,
        getBranchAverageTableConsumptionReport
    },
    product: {
        getProductCostSalesRatioReport
    },
    company: {
        getBranches
    },
    payment: {
        getBranchPaymentReport
    },
    customer: {
        getBranchCustomerCountReport
    },
    instant: {
        getBranchCustomerCountReport,
        getBranchOpenTableCountReport,
        getBranchStaffCountReport,
        getBranchUnpaidReport,
        getBranchGiftReport
    },
    dayTimes: {
        getBranchDayStartEndTimesReport
    },
    stock: {
        getBranchCriticalStockReport
    }
};

export default ReportService;